/**
 * Keeps variant-specific regions of the product page in sync with the selected
 * variant.
 *
 * Dawn already re-fetches the whole section from the Section Rendering API on
 * every variant change and publishes `variantChange` with the parsed document
 * attached (see product-info.js). This reuses that document, so there is no
 * additional network request -- only DOM swaps.
 *
 * Any element carrying `data-variant-swap` and an id has its contents replaced
 * from the element with the same id in the fetched document. That covers the
 * description, the "what's included" summary and the accessory list with one
 * mechanism, and anything added later needs no new JavaScript.
 *
 * The attribute's value, when set, names a class toggled on the element while
 * its content is empty, so a variant with nothing to show can collapse.
 *
 * Deliberately a subscriber rather than another `updateSourceFromDestination`
 * call inside product-info.js, so upgrading Dawn does not conflict.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const html = event?.data?.html;
    if (!html) return;

    document.querySelectorAll('[data-variant-swap]').forEach((destination) => {
      if (!destination.id) return;

      // Ids are section-scoped, so an element belonging to another section
      // simply will not be found in this section's fetched markup.
      const source = html.getElementById(destination.id);
      if (!source) return;

      destination.innerHTML = source.innerHTML;

      const emptyClass = destination.dataset.variantSwap;
      if (emptyClass) {
        destination.classList.toggle(emptyClass, source.innerHTML.trim() === '');
      }
    });
  });
})();
